import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration — finn-agentspace project (shared with FINN Spaces)
const firebaseConfig = {
    apiKey: "AIzaSyA8yAvm9t5BPbYYPew57VP9JN4GHlm6fXc",
    authDomain: "finn-agentspace.firebaseapp.com",
    projectId: "finn-agentspace",
    storageBucket: "finn-agentspace.firebasestorage.app",
    messagingSenderId: "520260363689",
    appId: "1:520260363689:web:404adf397624169ea990b8",
    measurementId: "G-XVW99B4K78"
};

const FIRESTORE_DATABASE_ID = 'spaces-db';

const app = initializeApp(firebaseConfig);

export const analytics = isSupported().then(supported =>
    supported ? getAnalytics(app) : null
);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Restrict Google Sign-In to FINN domain only
googleProvider.setCustomParameters({
    hd: 'finn.com',
    prompt: 'select_account',
});

export const db = getFirestore(app, FIRESTORE_DATABASE_ID);
export const storage = getStorage(app);

export const isFirebaseConfigured = () => firebaseConfig.apiKey.length > 0;
